import { defineMessages } from 'react-intl';

export const listPortletDisplayType = defineMessages({
  highlight: {
    id: 'portlet_display_type.highlight.title',
    defaultMessage: 'Highlight',
  },
  default: {
    id: 'portlet_display_type.default.title',
    defaultMessage: 'Default',
  },
});

export const listPortletType = defineMessages({
  search_record: {
    id: 'portlet_type.search_record.title',
    defaultMessage: 'Search record',
  },
  report: {
    id: 'portlet_type.report.title',
    defaultMessage: 'Report',
  },
});

export const listPortletViewType = defineMessages({
  pie: {
    id: 'portlet_view_type.pie.title',
    defaultMessage: 'Pie chart',
  },
  table: {
    id: 'portlet_view_type.table.title',
    defaultMessage: 'Tabular',
  },
  bar: {
    id: 'portlet_view_type.bar.title',
    defaultMessage: 'Bar chart',
  },
  line: {
    id: 'portlet_view_type.line.title',
    defaultMessage: 'Line chart',
  },
});
